import React from 'react';
import {
    FileText,
    Phone,
    MapPin,
    Calendar
} from 'lucide-react';

/**
 * Issue Categories Component
 * Displays breakdown of issues by category
 * @param {Object} props - Component props
 * @param {Object} props.issueCategories - Issue categories object with counts
 * @returns {JSX.Element} Issue categories grid
 */
export function IssueCategories({ issueCategories = {} }) {
    const {
        offers = 0,
        trackingNumbers = 0,
        counties = 0,
        globalRevisions = 0
    } = issueCategories;

    const categoriesData = [
        {
            id: 'offers',
            count: offers,
            label: 'Offers',
            icon: FileText,
            bgColor: 'bg-blue-50',
            iconColor: 'text-blue-600'
        },
        {
            id: 'tracking',
            count: trackingNumbers,
            label: 'Tracking Numbers',
            icon: Phone,
            bgColor: 'bg-purple-50',
            iconColor: 'text-purple-600'
        },
        {
            id: 'counties',
            count: counties,
            label: 'Counties',
            icon: MapPin,
            bgColor: 'bg-green-50',
            iconColor: 'text-green-600'
        },
        {
            id: 'revisions',
            count: globalRevisions,
            label: 'Revisions',
            icon: Calendar,
            bgColor: 'bg-indigo-50',
            iconColor: 'text-indigo-600'
        }
    ];

    return (
        <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
            <h3 className="text-lg font-semibold text-slate-900 mb-6">Issue Categories</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {categoriesData.map(({ id, count, label, icon: Icon, bgColor, iconColor }) => (
                    <div key={id} className="text-center">
                        <div className={`p-3 rounded-full ${bgColor} inline-block mb-3`}>
                            <Icon size={20} className={iconColor} />
                        </div>
                        <div className="text-xl font-bold text-slate-900">{count}</div>
                        <div className="text-sm text-slate-600">{label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default IssueCategories;
